import React from "react";
import { connect } from "react-redux";
import * as agent from "../agent";
import { MESSAGE_SENDED } from "../constants/actionTypes";
import InnerLink from "./InnerLink";
import { reduxForm, Field, reset } from "redux-form";
import { FormattedDate, FormattedTime } from "react-intl";
import { required } from "../utility";
import { MaterialTextField } from "./MaterialInput";
import Grid from "@material-ui/core/Grid";
import SubmitButton from "./SubmitButton";
import Paper from "@material-ui/core/Paper";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Typography from "@material-ui/core/Typography";

class creditComments extends React.Component {
    onAddComment = (creditId, data) => {
        const { dispatch, updateCredit } = this.props;
        agent.Credit.addComment(creditId, data)
            .then(res => {
                dispatch({
                    type: MESSAGE_SENDED,
                    payload: { text: `Комментарий добавлен`, type: "success" }
                });
                dispatch(reset("credit-comment-form"));
                updateCredit(res);
            })
            .catch(e =>
                dispatch({
                    type: MESSAGE_SENDED,
                    payload: { text: e.message, type: "error" }
                })
            );
    };

    render() {
        const { updateCredit, credit, handleSubmit } = this.props;
        const { _id, comments } = credit;
        return (
            <Paper
                className="common-paper"
                style={{ marginTop: 20, marginBottom: 20 }}
            >
                <Grid container justify="center" spacing={16}>
                    <Grid item className="common-column">
                        <form
                            className="common-form"
                            onSubmit={handleSubmit(data =>
                                this.onAddComment(_id, data)
                            )}
                        >
                            <Field
                                component={MaterialTextField}
                                rows={5}
                                multiline
                                validate={required}
                                name="text"
                                label="Комментарий"
                            />
                            <SubmitButton label="Добавить" />
                        </form>
                    </Grid>
                    <Grid item className="ultrawide-column">
                        {comments.length ? (
                            <Table padding="checkbox">
                                <TableHead>
                                    <TableRow>
                                        <TableCell>Дата</TableCell>
                                        <TableCell>Автор</TableCell>
                                        <TableCell>Комментарий</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {comments.map(
                                        (
                                            {
                                                _id,
                                                date,
                                                text,
                                                author: {
                                                    id,
                                                    fullname = ""
                                                } = {}
                                            },
                                            i
                                        ) => (
                                            <TableRow key={i}>
                                                <TableCell>
                                                    <FormattedDate
                                                        value={date}
                                                        day="numeric"
                                                        month="numeric"
                                                        year="numeric"
                                                    />
                                                    <br />
                                                    <FormattedTime
                                                        value={date}
                                                        hour="numeric"
                                                        minute="numeric"
                                                        second="numeric"
                                                    />
                                                </TableCell>
                                                <TableCell>
                                                    <InnerLink
                                                        target="_blank"
                                                        href={`/user/${id}`}
                                                        label={
                                                            fullname.split(
                                                                " "
                                                            )[0]
                                                        }
                                                    />
                                                </TableCell>
                                                <TableCell>{text}</TableCell>
                                            </TableRow>
                                        )
                                    )}
                                </TableBody>
                            </Table>
                        ) : (
                            <Typography>Заметок нет</Typography>
                        )}
                    </Grid>
                </Grid>
            </Paper>
        );
    }
}

const CreditComments = connect(
    null,
    null
)(reduxForm({ form: "credit-comment-form" })(creditComments));

export default CreditComments;



// WEBPACK FOOTER //
// ./src/components/CreditComments.js